$(document).ready(function (){
    $("#table-sections-details tbody").on('click','.delete-detail_section-item', function (e){
        let slug_book = $(this).data('slug_book')
        let section_id = $(this).data('section_id')
        let data = new FormData()
        data.append('slugBook',slug_book)
        data.append('sectionId',section_id)
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                $(".loader_").addClass("loading")
                sendInfo(data,'/admin/delete-item-detail')
            }
        })

    })

    function sendInfo(data,route) {
        $.ajax({
            method: "POST",
            url: route,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: data,
            success: function (response) {
                setTimeout(function () {
                    if (response.type == "success") {
                        $(".loader_").removeClass("loading")
                        showMsg(response.msg)
                    } else {
                        $(".loader_").removeClass("loading")
                        alertError(response.msg)
                    }
                }, 1000)
            }
        });
    }

    function showMsg(msg) {
       swal.fire({
            title: msg,
            confirmButtonText: 'Ok',
           confirmButtonColor: '#FF5000'
        }).then((result) => {
            location.reload()
        })
    }
})
